import styled from "styled-components"
import { device } from "breakpoints"
import { WhiteButton } from "components/globalComponents"
import { SelectInput } from "UI/SelectInput"
import { Col } from "UI/Grid"

export const FormWrapper = styled.div`
  @media ${device.desktop} {
    padding-right: 70px;
  }
`
export const PromptText = styled.p`
  margin-bottom: 15px;
  font-size: 15px;

  @media ${device.desktop} {
    font-size: 18px;
    margin-bottom: 25px;
  }
`

export const Label = styled.label`
  color: #2f3a46;
  font-size: 16px;
  display: inline-block;
  margin-bottom: 7px;
  position: relative;
  @media ${device.desktop} {
    font-size: 20px;
  }

  ::before {
    content: "";
    height: 6px;
    width: 6px;
    background-color: #ff5790;
    display: block;
    border-radius: 50%;
    position: absolute;
    top: 9px;
    right: -15px;
    display: none;
    display: ${(props) => props.required && "block"};

    @media ${device.desktop} {
      top: 12px;
    }
  }
`

export const SubmitButton = styled(WhiteButton)`
  margin-bottom: 20px;

  @media ${device.desktop} {
    margin-left: auto;
    float: right;
    width: 246px;
    margin-bottom:0;
  }
`

export const ContactSelectInput = styled(SelectInput)`
  width: 100%;
  margin-bottom: 20px;

  @media ${device.desktop} {
    margin-bottom: 22px;
  }
  .css-1hwfws3 {
    padding: 0;
  }

  .basic__control {
    height: 60px;
    background: white;
    border: 1px solid #e2e8ed;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding: 0 20px;
    @media ${device.desktop} {
      height: 73px;
      padding: 0 25px;
    }
    :hover {
    }

    &--menu-is-open {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  .basic__menu {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    box-shadow: none;
    border: 1px solid #e2e8ed;
    /* width: calc(100% - 0.5px); */
    margin-left: -0.5px;
    width: 100%;
    max-width: 100%;
    border-top: none;
  }

  .basic__menu-list {
    border: none;
    box-shadow: none;
    width: 100%;
    max-width: 100%;
  }
  .basic__option {
    font-size: 15px;
    padding: 15px 20px;
    color: #656f76;

    @media ${device.desktop} {
      font-size: 18px;
      padding: 17px 25px;
    }
  }

  .basic__option--is-selected {
    background: ${(props) => props.theme.teal};
    color: white;
  }

  span {
    font-size: 15px;
    color: #656f76;

    @media ${device.desktop} {
      font-size: 18px;
    }
  }

  svg {
    opacity: 0.5;
    path {
      stroke: #656f76;
    }
  }
`

export const SuccessMessage = styled.h3`
  br {
    display: none;
    @media ${device.desktop} {
      display: block;
    }
  }
`
